var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"main-container"},[_c('app-nav',{attrs:{"textColor":true}})],1),_vm._t("default"),_c('app-footer')],2)}
var staticRenderFns = []

export { render, staticRenderFns }